/**
 * What a person calls a panel: its title, trimmed, or "Panel 3" from its
 * place among the board's panels (`index` counts from 0) when it has no
 * title. The canvas heads each panel with it, so a message that names a
 * panel this way names it as the board shows it.
 */
export function panelCaption(title: unknown, index: number): string {
  const trimmed = typeof title === "string" ? title.trim() : "";
  return trimmed === "" ? `Panel ${index + 1}` : trimmed;
}

/**
 * A panel named inside a sentence: `the panel "Speeds"` for a panel with a
 * title, `Panel 3` for one without. Capitalize the first letter to start a
 * sentence with it.
 */
export function panelPhrase(title: unknown, index: number): string {
  const trimmed = typeof title === "string" ? title.trim() : "";
  return trimmed === "" ? `Panel ${index + 1}` : `the panel "${trimmed}"`;
}
